import { SET_SATSER, SatserActionTypes } from './Types';

export function satserReducer<T>(state: T | null = null, action: SatserActionTypes<T>): T | null {
    switch (action.type) {
        case SET_SATSER: {
            return action.payload;
        }
        default:
            return state;
    }
}
